import { SVGProps } from "react";

export function Check({ className }: SVGProps<SVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.23912 9.99501L7.11284 13.8687L15.4144 5.56799"
        stroke="currentColor"
        strokeWidth="1.56522"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
